const PortfolioHoldingsTable = require('./PortfolioHoldingsTable');

module.exports = PortfolioHoldingsTable;
